import React from 'react';
import { BlockStack, Card, Text, Checkbox, InlineStack } from '@shopify/polaris';
import { formatDateToUTC } from '#client/utils/helpers';
import { useProgramActions, useProgramInfo } from '#client/stores/program/useProgramStore';
import DatePicker from './DatePicker';

const ProgramInfo = () => {
    // Zustand store hooks
    const { mode, dateStart, dateExpires, taxExempt, freeShipping, isInStoreOnly, requireId, errors = {} } = useProgramInfo();
    const { setDateStart, setDateExpires, setTaxExempt, setFreeShipping, setIsInStoreOnly, setRequireId } = useProgramActions();

    const viewStatusMarkup = (
        <Card>
            <BlockStack gap="400">
                <Text as="h2" variant="headingLg">
                    Program Information
                </Text>
                <InlineStack gap="400">
                    <Text as="p" variant="bodyMd">
                        <strong>Start Date:</strong> {formatDateToUTC(dateStart)}
                    </Text>
                    <Text as="p" variant="bodyMd">
                        <strong>End Date:</strong> {formatDateToUTC(dateExpires)}
                    </Text>
                    <Text as="p" variant="bodyMd">
                        <strong>Tax Exempt:</strong> {taxExempt ? 'Yes' : 'No'}
                    </Text>
                    <Text as="p" variant="bodyMd">
                        <strong>In-Store Only:</strong> {isInStoreOnly ? 'Yes' : 'No'}
                    </Text>
                </InlineStack>
            </BlockStack>
        </Card>
    );

    const editStatusMarkup = (
        <Card>
            <BlockStack gap="400">
                <Text as="h2" variant="headingLg">
                    Program Information
                </Text>
                <BlockStack gap="400">
                    <InlineStack gap="400">
                        <BlockStack inlineAlign="center" gap="400">
                            <DatePicker label="Start date" value={dateStart} onChange={setDateStart} error={errors.dateStart} disableDatesBefore={new Date(new Date().setHours(0, 0, 0, 0))} />
                        </BlockStack>
                        <BlockStack inlineAlign="center" gap="400">
                            <DatePicker label="End date" value={dateExpires} onChange={setDateExpires} error={errors.dateExpires} disableDatesBefore={dateStart} />
                        </BlockStack>
                        <Checkbox label="Tax-Exempt" checked={taxExempt} onChange={setTaxExempt} error={errors.taxExempt} />
                        <Checkbox label="Free Shipping" checked={freeShipping} onChange={setFreeShipping} error={errors.freeShipping} />
                        <Checkbox label="Require ID" checked={requireId} onChange={setRequireId} error={errors.requireId} />
                        <Checkbox label="In-Store Only" checked={isInStoreOnly} onChange={setIsInStoreOnly} error={errors.isInStoreOnly} />
                    </InlineStack>
                </BlockStack>
            </BlockStack>
        </Card>
    );

    return mode === 'view' ? viewStatusMarkup : editStatusMarkup;
};

export default ProgramInfo;
